import { Link } from "react-router-dom";

export const Chip = ({ children, accent, onClick, active, testid }) => (
  <span onClick={onClick} data-testid={testid}
    className={`chip ${accent ? "chip-accent" : ""} ${onClick ? "cursor-pointer" : ""}`}
    style={active ? { background: "var(--brand-accent)", color: "#fff", borderColor: "var(--brand-accent)" } : {}}>
    {children}
  </span>
);

const ESTADO = {
  enviada: "var(--status-enviada)", vista: "var(--status-vista)",
  contactado: "var(--status-contactado)", contratado: "var(--status-contratado)",
  descartada: "var(--status-descartada)",
  abierta: "var(--status-contratado)", cerrada: "var(--brand-text-muted)",
  nuevo: "var(--status-enviada)", cliente: "var(--status-contratado)",
};

export const StatusBadge = ({ estado, testid, label }) => (
  <span data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold"
    style={{ background: `${ESTADO[estado] || "#94a3b8"}18`, color: ESTADO[estado] || "#64748b" }}>
    <span className="w-1.5 h-1.5 rounded-full" style={{ background: ESTADO[estado] || "#64748b" }} />
    {label || estado?.charAt(0).toUpperCase() + estado?.slice(1)}
  </span>
);

export const Section = ({ children, className = "" }) => (
  <div className={`max-w-7xl mx-auto px-4 sm:px-6 ${className}`}>{children}</div>
);

export const Stat = ({ value, label, testid }) => (
  <div className="text-center" data-testid={testid}>
    <div className="h-hero text-3xl sm:text-4xl lg:text-5xl" style={{ color: "var(--brand-accent)" }}>{value}</div>
    <div className="text-sm font-medium text-[var(--brand-text-muted)] mt-1">{label}</div>
  </div>
);

export const CTALink = ({ to, children, variant = "primary", testid }) => (
  <Link to={to} className={`btn-${variant} inline-block text-center`} data-testid={testid}>{children}</Link>
);
